"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcAccountSelector = class UcAccountSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_states = new core_1.ComponentValueCache(this, "states", () => this.$$load_states_cache_key());
    }
    $$load_states_cache_key() {
        return this.cacheKey ? ('AccountSelector.' + this.cacheKey) : null;
    }
    createAccountGrups(...args) {
        const [accounts] = args;
        const showInactive = this.states.showInactive;
        const accountType = this.accountType;
        return _
            .chain(accounts)
            .filter(p => accountType ? p.account_type === accountType : true)
            .groupBy(p => p.owner.id)
            .map((items, owner_id) => ({
            id: owner_id,
            name: items[0].owner.code + ' - ' + items[0].owner.name,
            items: !showInactive ? _.filter(items, { inactive: false }) : items
        }))
            .filter(p => p.items.length)
            .value();
    }
    itemChanged(...args) {
        const [item, value] = args;
        if (value == null || item == null) {
            return true;
        }
        return value.id != item.id;
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    displayOwner;
    onDisplay_owner(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("displayOwner");
    }
    cacheKey;
    onCache_key(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("cacheKey");
    }
    accountType;
    onAccount_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("accountType");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    accounts;
    async $$load_accounts() {
        return this.$fn.fetch('list_account')
            .then(resp => _.orderBy(resp.data, ['inactive', 'account_type', 'name'], ['asc', 'desc', 'asc']));
    }
    hasInactiveItem;
    async $$load_hasInactiveItem() {
        return _.some(this.$data.accounts, { inactive: true });
    }
    accountGroups;
    async $$load_accountGroups() {
        return this.createAccountGrups(this.$data.accounts);
    }
    states;
    ux;
    dataMembers = ['accounts', 'hasInactiveItem', 'accountGroups', 'states', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                accounts: null,
                hasInactiveItem: null,
                accountGroups: null,
                states: {
                    selectedAccountId: null,
                    showInactive: false,
                },
                ux: null,
            },
        };
    }
    get selectedAccountType() {
        if (this.loaded) {
            return this.value && this.value.account_type;
        }
        return null;
    }
    get selectedAccount() {
        if (this.loaded) {
            return _.isObject(this.value) ? this.value : null;
        }
        return null;
    }
    async act_1468474219929533_setData_6312_getActionArgs($event) {
        return {
            path: "accountGroups",
            value: this.createAccountGrups(this.accounts),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1468474219929533_change(event, scope) {
        return await this.actions.evh_1468474219929533_change.executeFromDOM(this, event, scope);
    }
    async act_1306227577716690_emit_6314_getActionArgs($event) {
        return {
            event: "input",
            value: $event.scope.item,
        };
    }
    async evh_1306227577716690_clickPrevent_6313_getWhen($event) {
        return this.itemChanged($event.scope.item, this.value);
    }
    async act_1306227577716690_setData_6316_getActionArgs($event) {
        return {
            path: "states.selectedAccountId",
            value: $event.scope.item.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1306227577716690_clickPrevent(event, scope) {
        return await this.actions.evh_1306227577716690_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1468474219929533_setData_6312 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1468474219929533_setData_6312_getActionArgs,
            events: [],
        });
        const evh_1468474219929533_change_6311 = new core_1.actions.EventHandlerImpl({
            action: act_1468474219929533_setData_6312,
            event: "change",
            displayName: "setData",
        });
        const evh_1468474219929533_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1468474219929533_change_6311],
        });
        const act_1306227577716690_emit_6314 = new core_1.actions.EmitAction({
            actionArgs: this.act_1306227577716690_emit_6314_getActionArgs,
            events: [],
        });
        const evh_1306227577716690_clickPrevent_6313 = new core_1.actions.EventHandlerImpl({
            action: act_1306227577716690_emit_6314,
            event: "click.prevent",
            when: this.evh_1306227577716690_clickPrevent_6313_getWhen,
            displayName: "emit",
        });
        const act_1306227577716690_setData_6316 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1306227577716690_setData_6316_getActionArgs,
            events: [],
        });
        const evh_1306227577716690_clickPrevent_6315 = new core_1.actions.EventHandlerImpl({
            action: act_1306227577716690_setData_6316,
            event: "click.prevent",
            displayName: "setData",
        });
        const evh_1306227577716690_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1306227577716690_clickPrevent_6313, evh_1306227577716690_clickPrevent_6315],
        });
        return {
            act_1468474219929533_setData_6312,
            evh_1468474219929533_change_6311,
            evh_1468474219929533_change,
            act_1306227577716690_emit_6314,
            evh_1306227577716690_clickPrevent_6313,
            act_1306227577716690_setData_6316,
            evh_1306227577716690_clickPrevent_6315,
            evh_1306227577716690_clickPrevent,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({}),
    __metadata("design:type", Object)
], UcAccountSelector.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAccountSelector.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcAccountSelector.prototype, "displayOwner", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('displayOwner'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAccountSelector.prototype, "onDisplay_owner", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcAccountSelector.prototype, "cacheKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('cacheKey'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAccountSelector.prototype, "onCache_key", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcAccountSelector.prototype, "accountType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('accountType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAccountSelector.prototype, "onAccount_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcAccountSelector.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAccountSelector.prototype, "onReadonly", null);
UcAccountSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcAccountSelector);
exports.default = UcAccountSelector;
vue_property_decorator_1.Vue.component("UcAccountSelector", UcAccountSelector);
